import { render, staticRenderFns } from "./beta.vue?vue&type=template&id=3cfceb58&scoped=true&"
import script from "./beta.vue?vue&type=script&lang=js&"
export * from "./beta.vue?vue&type=script&lang=js&"
import style0 from "./beta.vue?vue&type=style&index=0&id=3cfceb58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfceb58",
  null
  
)

export default component.exports